export default __webpack_public_path__ + "static/media/REC_APP.2fd71f20.svg";